<template lang="pug">
div.has-fixed-footer
    div(v-if="collection")
        .card.mb-3(v-if="collection.parent_collection")
            .card-body.py-2
                strong Parent collection:
                span.ml-2(v-if="parentCollection")
                    router-link(:to="'/collections/' + parentCollection.id") {{parentCollection.name}}
                    span.text-muted.ml-2 ({{parentCollection.id}})
                span.ml-2(v-else)
                    router-link(:to="'/collections/' + collection.parent_collection") {{collection.parent_collection}}
        CollectionEditCard.mb-3(
          v-model="collection" @changedCollection="onChanged"
        )
        CollectionTable(v-if="subcollections.length", :collections="subcollections", :showFactColumn="false")
    .alert.alert-warning(v-else-if="err") {{err.message}}
</template>
<script>
import CollectionTable from "./CollectionTable.vue";
import CollectionEditCard from "./CollectionEditCard";
import {getCollection, getCollectionsByParent, getAlsoKnownByCollection} from "../api";

export default {
    components: {CollectionTable, CollectionEditCard},
    data() {
        return {
            collection: null,
            parentCollection: null,
            subcollections: [],
            isChanged: false,
            err: null,
            sop_values: [
            "sample_processing_sop",
            "sample_transport_sop",
            "sample_storage_sop",
            "data_processing_sop",
            "data_transport_sop",
            "data_storage_sop"
            ],
            access_values: ["data","samples","images"]
        }
    },
    created(){
      console.log("created "+this.$route.params.id)
        this.fetchData(this.$route.params.id);
        // console.log("created top "+this.collection.id)
    },
    beforeRouteUpdate(to, from, next) {
        this.fetchData(to.params.id);
        next();
    },
    methods: {
        scrollToTop() {
            this.$nextTick(() => {
                const appMain = document.querySelector(".app-main");
                if (appMain) appMain.scrollTop = 0;
                window.scrollTo(0, 0);
                document.documentElement.scrollTop = 0;
                document.body.scrollTop = 0;
            });
        },
        fetchData(collectionId) {
            return Promise.all([
                getCollection(collectionId)
                .then((collection) => {
                  this.initAttributeFromString("sop", collection, this.sop_values);
                  this.initAttributeFromString("access_fee", collection, this.access_values);
                  this.initAttributeFromString("access_joint_project", collection, this.access_values);
                  this.collection = collection;
                  if (collection.parent_collection) {
                    return getCollection(collection.parent_collection)
                        .then(parent => this.parentCollection = parent)
                        .catch(() => this.parentCollection = null);
                  }
                  this.parentCollection = null;
                  return Promise.resolve();
                }),
                getCollectionsByParent(collectionId)
                .then(subcollections => this.subcollections = subcollections)
            ]).then(() => {
                this.scrollToTop();
            })
            .catch(err => this.err = err);
        },
      onChanged(isChanged) {
        this.isChanged = isChanged;
      },
      initAttributeFromString(name, collection, allValues) {

        collection[name+"_New"] = {}

        allValues.forEach((val)=>{
          collection[name+"_New"][val] = false;
        });

        if (collection[name] == null) return;

        let valArray = collection[name].split(",");

        valArray.forEach((val) => {
          collection[name+"_New"][val] = true;
        });

      },

    }
}
</script>
